import React  from 'react';
import { connect } from 'react-redux'
import { createEvent, returnFromEditCreateEvent } from '../../actions'
import EventForm from './EventForm'
import { parseDate } from '../helpers/DateUtils'
import { CREATOR } from '../helpers/AppConsts' 
import { GA_TRACKING_CREATE_PAGE } from '../helpers/AppConsts'
import ReactGA from 'react-ga';

class EventCreate extends React.Component{
  
  componentDidMount(){
    ReactGA.ga('send', 'pageview', GA_TRACKING_CREATE_PAGE);
  }


  onSubmit = (formValues) => {
      formValues.event_organizer = this.props.currentUserEmail;
      formValues.userEmail = this.props.currentUserEmail;
      formValues.event_date = parseDate(formValues.event_year, formValues.event_month, formValues.event_day);
      formValues.event_notes= (formValues.notes) ? formValues.notes : 'Not specified.';
      
      this.props.createEvent(formValues);
  }

  onReturn = (formValues) => {
    this.props.returnFromEditCreateEvent();
  }

  renderEventForm = () => {
    return <EventForm onSubmit={this.onSubmit}/>
  }

  render () {
      return (
       <div>
        <div className="ui container">
          <h2>Create Event</h2>
          
          {this.renderEventForm()}
          <br/>
          <button className="ui button positive" onClick={this.onReturn}>
            Return
          </button>
        </div>
       </div>
      );
  }
};

const mapStateToProps = (state) => {
  return {
    currentUserEmail: CREATOR
  };
}

export default connect(mapStateToProps, {createEvent,returnFromEditCreateEvent})(EventCreate)
